import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Edit as EditIcon, Delete } from '@mui/icons-material';
import { AddressType } from '../../../../../../services/RegistrationService/registrationSlice/';

interface ActionsTemplateProps {
  address: AddressType;
  onEdit: (address: AddressType) => void;
  onDelete: (addressType: string) => void;
}

/**
 * Actions template for edit/delete buttons
 */
export const ActionsTemplate: React.FC<ActionsTemplateProps> = ({ address, onEdit, onDelete }) => (
  <Box display="flex" gap={1}>
    <IconButton size="small" onClick={() => onEdit(address)} sx={{ color: '#3b82f6' }}>
      <EditIcon fontSize="small" />
    </IconButton>
    <IconButton
      size="small"
      onClick={() => onDelete(address.addressType)}
      sx={{ color: '#ef4444' }}
    >
      <Delete fontSize="small" />
    </IconButton>
  </Box>
);

export default ActionsTemplate;
